import { render, staticRenderFns } from "./sundry-receipt.vue?vue&type=template&id=ab8f2d30"
import script from "./sundry-receipt.vue?vue&type=script&lang=js"
export * from "./sundry-receipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports